import { useEffect } from "react"
import { Button } from "@brainfinance/icash-component-library"

import { postMessageSender } from "../../../Helpers/PostMessage"

import successIcon from "../../../images/identity-verification/success-product-icon.svg"

export function IdentityVerificationSuccess() {
  useEffect(() => {
    postMessageSender({
      event: "marketing",
      payload: {
        status: "screen",
        data: {
          categoryName: "Application",
          pathName: "app_identity_verification_success_loaded",
        },
      },
    })
  }, [])

  const handleBackToHome = () => {
    postMessageSender({ event: "finished" })
  }

  return (
    <div className="max-w-[622px] w-full">
      <div className="flex justify-center mb-[32px]">
        <img
          src={successIcon}
          alt="Verification successful"
        />
      </div>

      <p className="caption-light-no-color !text-[#13141A]">
        Thanks for Applying!
        <br /><br/>
        Your application is being reviewed and we'll be in touch shortly.<br/>
        If approved, we'll send you an email with a secure link to digitally sign your loan agreement. Once signed, the funds will be sent to you via e-Transfer without delay!
      </p>

      <Button
        size="large"
        appearance="primary"
        className="!w-full !mt-[32px]"
        onClick={handleBackToHome}
      >
        Back to Home
      </Button>
    </div>
  )
}
